import OutlineFilterInput from "components/Conversations/Views/Drawer/components/DeepFilter/OutlineFilterInput";
import { observer } from "mobx-react";
import { IApplicationFilterComponent } from "../BaseFilterComponents/IApplicationFilterComponent";
import React from "react";

export const OutlineFilter = observer(function (
    props: IApplicationFilterComponent,
) {
    return <OutlineFilterInput store={props.store.outlineFilterStore} />;
});
